import React from "react";
import "./index.css";
// import App from './App'
import store from "./store/store";
import { globalTheme } from "./themes";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import LangRouter from "./ts/routing/LangRouter";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <Provider store={store}>
      <ThemeProvider theme={globalTheme}>
        <CssBaseline />
        <BrowserRouter>
          {/* <App /> */}
          <LangRouter />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
